/* COMPONENT - c.11.01 - Wheelchair Selection */
'use strict';

import axios from "axios";
import WheelchairModelOverlay from "./c11.04_wheelchair-model-overlay.js";

export default class WheelchairSelection {

  constructor() {
    this.apiClient = axios.create({
      withCredentials: false,
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
        'Content-Type': 'application/json',
      },
    });

    const additionalHtml = document.querySelector('.js-wheelchair-additional');

    this.accessoryTotal = 0;
    this.deliveryMethodPrice = 0;

    if(additionalHtml !== null) {
      this.durationSelector = document.querySelector('select[data-duration-select]');
      this.selectedDuration = parseFloat(this.durationSelector.options[this.durationSelector.selectedIndex].value); //Default value
      this.durationOutputs = document.querySelectorAll('[data-duration-output]');

      this.toggleAccordion();
      this.toggleAdditional();

      //User selects new duration for equipment booking
      this.durationSelector.addEventListener('change', this.handleDurationChange.bind(this, this.durationSelector));
      this.handleDurationChange(this.durationSelector);

      //Check if no radio button exists, load additional content if not
      this.revealAdditionalContent();
    }

    this.revealAdditionalInformationOnMount();
  }

  revealAdditionalInformationOnMount() {
    // Get both delivery methods
    const pickupOption = document.getElementById('pickup');
    const deliveryOption = document.getElementById('delivery');

    // If the method is delivery only, we want to 'click' the delivery option to reveal the rest of the form
    if (!pickupOption && deliveryOption) {
      deliveryOption.click();
    }

    if (pickupOption && !deliveryOption) {
      pickupOption.click();
    }
  }

  /** Reveals additional content IF only one option is showing */
  revealAdditionalContent() {
    const noRadio = [...document.querySelectorAll('.js-no-radio')];
    const additionalContent = document.querySelector('.js-wheelchair-additional');

    noRadio.forEach(el => {
      if (el && additionalContent.hasAttribute('hidden')) {
        const elInput = el.querySelector('input');
        document.querySelector('.js-wheelchair-additional').removeAttribute('hidden');
        document.querySelector('.js-delivery-method').setAttribute('hidden', '');

        elInput.click();
        elInput.checked = true;
      }
    })

    
  }

  toggleAccordion() {
    const accordionTrigger = document.querySelector('.js-toggle');
    
    accordionTrigger.addEventListener('click', (e) => {
      e.preventDefault();

      if (accordionTrigger.getAttribute('aria-expanded') === 'false') {
        accordionTrigger.setAttribute('aria-expanded', 'true');
        accordionTrigger.parentNode.classList.add('is-open');
        accordionTrigger.classList.add('is-open');
  
        accordionTrigger.nextElementSibling.removeAttribute('hidden');
      } else {
        accordionTrigger.setAttribute('aria-expanded', 'false');
        accordionTrigger.parentNode.classList.remove('is-open');
        accordionTrigger.classList.remove('is-open');
  
        accordionTrigger.nextElementSibling.setAttribute('hidden', '');
      }
    });
  }

  changeDurationText(duration) {
    //Re-set outputs - these can be added by the accessories selection
    this.durationOutputs = document.querySelectorAll('[data-duration-output]');
    //Change all duration outputs
    for (let i = 0; i < this.durationOutputs.length; i++) {
        this.durationOutputs[i].textContent = duration + ` ${this.selectedDuration > 1 ? 'weeks' : 'week'}`;
    }
  }

  handleDurationChange(select) {
    const accessoryListOutput = document.querySelector('[data-accessories-list]');
    const hiddenInputDuration = document.querySelector('input[name=duration]');
    const accessoryList = accessoryListOutput.querySelectorAll('[data-accessory-price]');

    this.selectedDuration = parseFloat(select.options[select.selectedIndex].getAttribute('data-duration-option'));

    hiddenInputDuration.setAttribute('value', this.selectedDuration);
    
    this.changeDurationText(this.selectedDuration);

    this.accessoryDurationTotal = this.accessoryTotal * this.selectedDuration;

    for (let i = 0; i < accessoryList.length; i++) {
      let accessoryPrice = (parseFloat(accessoryList[i].textContent) * this.selectedDuration);
      let accessoryCostOutput = accessoryList[i];
      accessoryCostOutput.setAttribute('data-accessory-price', accessoryPrice);
    }

    this.updateCost();
  }

  getAdditional() {
    const endpoint = 'brc-api/wheelchair/accessories';
    const type = document.querySelector('input[name="delivery-options"]:checked').value;
    const journeyKey = document.querySelector(`select[data-radio-type="${type}"]`).value;
    return this.apiClient({url:`${endpoint}?journeyKey=${journeyKey}`, baseURL: window.location.origin})
  }

  additonalItems(element) {
    const additionalContent = document.querySelector('.js-wheelchair-additional');
    const deliveryMethodEl = document.querySelector('.js-delivery-method');
    const totalAccessoriesEl = document.querySelector('.js-total-accessories');
    const wheelchairAccessories = document.querySelector('.js-wheelchair-accessories');
    const wheelchairAddressForm = document.querySelector('.js-address-form');
    const productPriceEl = document.querySelector('.js-product-price');
    const productPriceVal = document.querySelector('.js-product-price-val');
    const presentationPrice = document.querySelector('.js-presentation-price');
    const priceRte = document.querySelector('.js-product-price-rte');
    const equipmentText = document.querySelector('.js-equipment');
    const radioPrice = element.getAttribute('data-radio-price');
    let deliveryTotalVal = document.querySelector('.js-delivery-total');
    let productOriginalPrice = document.querySelector('.js-product-price').getAttribute('data-product-original-price');

    if (element.getAttribute('data-radio-type') === 'pickup') {
      wheelchairAddressForm.setAttribute('hidden', 'true');
      deliveryMethodEl.style.display = 'none';
      deliveryMethodEl.setAttribute('data-delivery-price', '0');
      deliveryTotalVal.innerText = '£0.00';
    } else if (element.getAttribute('data-radio-type') === 'delivery') {
      wheelchairAddressForm.removeAttribute('hidden');
      deliveryMethodEl.style.display = 'block';
      deliveryMethodEl.setAttribute('data-delivery-price', radioPrice);
      deliveryTotalVal.innerText = `£${parseFloat(radioPrice).toFixed(2)}`;
    }

    this.deliveryMethodPrice = parseFloat(deliveryMethodEl.getAttribute('data-delivery-price'));

    this.getAdditional().then(r => {
        r.data.accessoryMarkup ? wheelchairAccessories.removeAttribute('hidden') : wheelchairAccessories.setAttribute('hidden', true);
        totalAccessoriesEl.innerHTML = '';
        wheelchairAccessories.innerHTML = r.data.accessoryMarkup;

        if (element.getAttribute('data-radio-type') === 'pickup') {
          productPriceEl.setAttribute('data-product-price', `${r.data.chairPrice}`);
          productPriceVal.innerText = `£${r.data.chairPrice}`;
        } else if (element.getAttribute('data-radio-type') === 'delivery') {
          productPriceEl.setAttribute('data-product-price', `${r.data.chairPrice}`);
          productPriceVal.innerText = `£${r.data.chairPrice}`;
        }

        if(r.data.chairPrice === '0.00' || r.data.chairPrice === '0') {
          presentationPrice.setAttribute('hidden', true);
          priceRte.removeAttribute('hidden');
          equipmentText.setAttribute('hidden', true);
        } else {
          presentationPrice.removeAttribute('hidden');
          priceRte.setAttribute('hidden', true);
          equipmentText.removeAttribute('hidden');
        }

        new WheelchairModelOverlay(
          additionalContent.querySelectorAll(".js-open-overlay"),
          additionalContent.querySelectorAll(".js-overlay"),
        );

        this.accessoryTotal = 0;
        this.accessoryDurationTotal = this.accessoryTotal * this.selectedDuration;
        this.toggleAccessories();
        this.updateCost(); 
    })
    .catch(() => {
      wheelchairAccessories.removeAttribute('hidden');
      productPriceEl.setAttribute('data-product-price', `${productOriginalPrice}`);
      productPriceVal.innerText = `£${productOriginalPrice}`;
      
      wheelchairAccessories.innerHTML = 
        `<div class="wheelchair-accessories__item-alert">
          <span class="icon-error-cross" style="background-image: none;">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M15.364 2.634a9.005 9.005 0 0 0-12.728 0 8.988 8.988 0 0 0 0 12.718 8.97 8.97 0 0 0 12.728 0 8.988 8.988 0 0 0 0-12.718z" fill="#D0021B"></path>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M9.778 9l3.11 3.111-.777.778L9 9.778l-3.111 3.11-.778-.777L8.222 9 5.111 5.889l.778-.778 3.11 3.111 3.112-3.111.778.778-3.111 3.11z" fill="#fff"></path>
              <path d="M12.889 12.111l.346-.346.347.346-.347.347-.346-.347zM9.778 9l-.347.346L9.085 9l.346-.347.347.347zm2.333 3.889l.346.346-.346.347-.346-.347.346-.346zM9 9.778l-.347-.347L9 9.085l.346.346L9 9.778zm-3.111 3.11l.346.347-.346.347-.347-.347.347-.346zm-.778-.777l-.347.346-.346-.346.346-.347.347.347zM8.222 9l.346-.347.347.347-.347.346L8.222 9zM5.111 5.889l-.346.346-.347-.346.347-.347.346.347zm.778-.778l-.347-.346.347-.347.346.347-.346.346zm3.11 3.111l.347.347L9 8.915l-.347-.346L9 8.222zm3.112-3.111l-.347-.347.347-.346.346.346-.346.347zm.778.778l.346-.347.347.347-.347.346-.346-.346zm-.347 6.569l-3.11-3.112.692-.693 3.111 3.112-.693.693zm-.777.085l.777-.778.693.693-.777.777-.693-.692zM9.346 9.43l3.111 3.112-.692.692-3.112-3.11.693-.694zm-3.804 3.111l3.111-3.11.693.692-3.11 3.111-.694-.693zm-.085-.777l.778.777-.693.693-.778-.777.693-.694zm3.111-2.419l-3.11 3.111-.694-.693 3.112-3.11.692.692zm-3.11-3.804l3.11 3.111-.692.693-3.111-3.11.693-.694zm.777-.084l-.777.777-.693-.693.777-.777.693.693zm2.418 3.11l-3.11-3.11.692-.693 3.111 3.11-.693.694zm3.804-3.11l-3.11 3.11-.694-.692 3.111-3.112.694.693zm.085.777l-.777-.778.692-.693.778.778-.693.693zm-3.11 2.418l3.11-3.11.693.692-3.11 3.111-.694-.693z" fill="#fff"></path>
            </svg>
          </span>
          Error: Unable to load additional accessories
        </div>`;

        this.updateCost(); 
    });

    additionalContent.removeAttribute('hidden');
  }

  toggleAdditional() {
    const _self = this;
    const additionalTrigger = document.querySelectorAll('.js-wheelchair-radio');
    const additionalTriggerArray = Array.prototype.slice.call(additionalTrigger);
    const dateSelectEl = [...document.querySelectorAll('.js-date-select')];

    dateSelectEl.forEach((element, index) => {
      element.addEventListener('change', () => {
        if (additionalTriggerArray[index].querySelector('input').checked) {
          _self.additonalItems(element);
        } else {
          additionalTriggerArray[index].querySelector('input').click();
          additionalTriggerArray[index].querySelector('input').checked = true;
        }
      })
    });

    additionalTriggerArray.forEach((element) => {
      element.addEventListener('change', (e) => {
        e.preventDefault();
        element.setAttribute('aria-expanded', 'true');
        _self.additonalItems(element);
      });
    });
  }

  toggleAccessories() {
    const _self = this;
    const wheelchairAdditionals = document.querySelector('.js-wheelchair-accessories');

    if (typeof(wheelchairAdditionals) !== 'undefined' && wheelchairAdditionals !== null) {
      const accessoryCheckBoxes = document.querySelectorAll('.js-add-accessory');
      const accessoryCheckBoxesArray = Array.prototype.slice.call(accessoryCheckBoxes);
      const accessoryListOutput = document.querySelector('.js-total-accessories');

      accessoryCheckBoxesArray.forEach((element) => {
        const elementInput = element.querySelector('input');

        elementInput.addEventListener('change', () => {
          const isChecked = elementInput.checked;
          const accessoryName = elementInput.getAttribute('data-accessory-name');
          const accessoryPrice = parseFloat(elementInput.getAttribute('data-accessory-price'));
          const accessoryCost = accessoryPrice * this.selectedDuration;

          let accessoryListOutputContent = accessoryListOutput.innerHTML;

          if (isChecked) {
            element.classList.add('is-active');
            element.querySelector('label').innerText = 'Added';
            accessoryListOutputContent += `<span data-accessory-name="${accessoryName}">${accessoryName}: £<span data-accessory-price="${accessoryCost}">${accessoryPrice}</span> x <span data-duration-output>${this.selectedDuration} ${this.selectedDuration > 1 ? 'weeks' : 'week'}</span>`;
            accessoryListOutput.innerHTML = accessoryListOutputContent;

            _self.accessoryTotal += parseFloat(accessoryPrice);
          } else {
            element.classList.remove('is-active');
            element.querySelector('label').innerText = 'Add';
            document.querySelector('.js-total-accessories').querySelector(`[data-accessory-name="${accessoryName}"]`).remove();

            _self.accessoryTotal -= parseFloat(accessoryPrice);
          }

          _self.accessoryDurationTotal = _self.accessoryTotal * _self.selectedDuration;
          _self.updateCost();
        });
      });
    }
  }

  updateCost() {
    const grandTotalEl = document.querySelector('.js-total');
    const productPrice = parseFloat(document.querySelector('.js-product-price').getAttribute('data-product-price'));
    const productPriceDuration = productPrice * this.selectedDuration;
    let equipmentTotal = document.querySelector('.js-equipment');
    let equipmentTotalVal = document.querySelector('.js-equipment-total');
    let grandTotalVal = productPriceDuration + this.deliveryMethodPrice + this.accessoryDurationTotal;

    //Generate equipment total from the product price
    equipmentTotal.setAttribute('data-equipment-price', productPrice);
    equipmentTotalVal.innerHTML = `£${productPrice.toFixed(2)} x <span data-duration-output>${this.selectedDuration} ${this.selectedDuration > 1 ? 'weeks' : 'week'}</span>`;

    //Generate grand total
    grandTotalEl.innerText = `£${grandTotalVal.toFixed(2)}`;
    grandTotalEl.setAttribute('data-grand-total', grandTotalEl.innerText.replace('£',''));
  }
}
